import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import Image from "src/Components/Common/Image";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_DOW_DEMO_DNA1_1 = {
  title:
    "Meet Lyn, a Data Operations Executive \nmanaging the Analytics Platform for a \nlarge Telco. She is exploring ways to \neffectively monitor the health of the \nanalytics platform.",
  subtitle: "Data Operations Workbench demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(106),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{
            position: "absolute",
            bottom: "121px",
            right: "640px",
            zIndex: 1,
          }}
          imagePath="DNA1/DNA1_demo_1_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "800px",
            height: "auto",
            bottom: "0px",
            right: "-99px",
          }}
          imagePath="characters/character_dna1_1.gif"
        />
      </div>
    </div>
  ),
};
